// ES
export const accomMgmt = {
  common: {
    cancel: "Cancelar",
    save: "Guardar",
    update: "Actualizar",
    back: "Atrás",
    continue: "Continuar",
    optional: "(opcional)",
    optionalPlaceholder: "Opcional",
    processing: "Procesando...",
    name: "Nombre",
    description: "Descripción",
    nameRequired: "El nombre es obligatorio.",
  },

  type: {
    apartment: "Apartamento turístico",
    hotel: "Hotel",
    camping: "Camping",
    villa: "Villa",
  },

  step: {
    type: "Tipo",
    structure: "Estructura",
    accommodation: "Alojamiento",
  },

  step1: {
    title: "¿Qué tipo de alojamiento tienes?",
    subtitle: "Selecciona el tipo de alojamiento.",
    subtitleQuota: "Verás activos sólo los tipos con cupo disponible en tu plan.",
    subtitleFirst: "Como es tu primer alojamiento, puedes elegir cualquier tipo.",
    remaining: "restantes: {count}",
    loadingQuota: "Cargando cupos de tu plan…",
  },

  step2: {
    title: "Configura tu alojamiento",
    subtitle:
      "Define si será un alojamiento independiente o un alojamiento con multiples calendarios (varias unidades bajo un mismo alojamiento).",
    singleTitle: "Un único espacio",
    singleChip: "1 calendario",
    singleDesc: "Alquilar todo el apartamento completo usando un único calendario.",
    groupedTitle: "Varios espacios",
    groupedChip: "Varios calendarios",
    groupedDesc: "Alquilas varios espacios independientes dentro del apartamento",
  },

  step3: {
    title: "Configura el alojamiento principal",
    subtitle:
      "Este será el “contenedor” (Listing) que agrupa varios calendarios. Ej: “Suite del Castillo”.",
    panelTitle: "Elige una opción",
    availableCount: "Tienes {count} alojamientos grouped disponibles.",
    noneAvailable: "No hay anuncios grouped disponibles para este tipo (crea uno nuevo).",
    newTitle: "Crear un alojamiento principal nuevo",
    newDesc: "Tú defines el nombre del alojamiento principal.",
    nameLabel: "Nombre del alojamiento principal",
    namePlaceholder: "Ej: Suite del Castillo",
    nameHelp: "Este nombre se guardará y podrás agrupar varios calendarios.",
    minChars: "Escribe al menos 3 caracteres.",
    existingTitle: "Añadir a alojamiento existente",
    existingDesc: "La unidad quedará dentro de un alojamiento ya creado.",
    selectLabel: "Selecciona el alojamiento",
    selectPlaceholder: "Selecciona un alojamiento…",
    listingOption: "{name} · {units} unidad(es)",
    ready: "Listo",
    noneForType: "No tienes alojamientos grouped disponibles para este tipo.",
    tip: "Tip: este “principal” será el contenedor donde se agregará la nueva unidad.",
  },

  preview: {
    tab: "tualojamiento",
    perNight: "/Noche",
    book: "Reservar",
    locationPlaceholder: "País, ciudad, calle",
    guests: "{count} huésped | {count} huéspedes",
    bedrooms: "{count} habitación | {count} habitaciones",
    bathrooms: "{count} baño | {count} baños",
    amenitiesTitle: "Servicios",
    amenitiesEmpty: "Seleccionar para añadir servicios a tu alojamiento",
    locationTitle: "Ubicación",
    locationEmpty: "Indicar la ubicación",
    descriptionTitle: "Descripción",
    descriptionEmpty: "Seleccionar para añadir una descripción a tu alojamiento",
    namePlaceholder: "Nombre del alojamiento",
    amenity: {
      air_conditioning: "Aire acondicionado",
      heating: "Calefacción general",
      parking: "Plaza de aparcamiento",
      oven: "Horno y placa",
      pets_allowed: "Se permiten mascotas",
      wifi: "Internet WiFi",
      essentials: "Esenciales",
      washing_machine: "Lavadora",
      children_allowed: "Se permiten niños",
      refrigerator: "Nevera",
    },
  },

  amenities: {
    title: "Equipamiento y comodidades",
    subtitle: "Indica qué ofrece tu alojamiento para que los huéspedes sepan qué esperar.",
    searchPlaceholder: "Buscar comodidad…",
    selectedCount:
      "{count} comodidad seleccionada | {count} comodidades seleccionadas",
    noResults: 'No se encontraron comodidades para "{search}".',
    cat: {
      all: "Todas",
      basics: "Servicios básicos",
      bathroom: "Baño",
      bedroom: "Dormitorio y lavandería",
      kitchen: "Cocina y comedor",
      outdoor: "Exterior",
      leisure: "Ocio y entretenimiento",
      safety: "Seguridad",
      family: "Familias",
      parking: "Aparcamiento",
      services: "Servicios",
      connectivity: "Conectividad",
      accessibility: "Accesibilidad",
    },
    item: {
      wifi: "Wifi",
      essentials: "Servicios básicos",
      air_conditioning: "Aire acondicionado",
      heating: "Calefacción",
      indoor_fireplace: "Chimenea interior",
      hot_water: "Agua caliente",
      hangers: "Perchas",
      bed_linen: "Ropa de cama",
      towels: "Toallas",
      shampoo: "Champú",
      shower_gel: "Gel de ducha",
      conditioner: "Acondicionador",
      hair_dryer: "Secador de pelo",
      bathtub: "Bañera",
      bidet: "Bidé",
      jacuzzi: "Jacuzzi",
      outdoor_shower: "Ducha exterior",
      washing_machine: "Lavadora",
      dryer: "Secadora",
      iron: "Plancha",
      clothes_drying_rack: "Tendedero para ropa",
      extra_pillows: "Almohadas y mantas adicionales",
      wardrobe: "Espacio para guardar la ropa",
      blackout_curtains: "Persianas o cortinas opacas",
      nearby_laundry: "Lavandería cercana",
      oven: "Horno",
      refrigerator: "Nevera",
      freezer: "Congelador",
      microwave: "Microondas",
      dishwasher: "Lavavajillas",
      cooking_basics: "Utensilios básicos de cocina",
      plates_cutlery: "Platos y cubiertos",
      wine_glasses: "Copas de vino",
      coffee_maker: "Cafetera",
      coffee: "Café",
      kettle: "Hervidor de agua",
      toaster: "Tostadora",
      blender: "Batidora",
      rice_cooker: "Arrocera",
      bread_maker: "Panificadora",
      mini_fridge: "Frigorífico pequeño",
      stovetop: "Fogones",
      dining_table: "Mesa de comedor",
      baking_sheet: "Bandeja de repostería",
      bbq_grill: "Barbacoa",
      bbq_utensils: "Utensilios de barbacoa",
      outdoor_kitchen: "Cocina exterior",
      outdoor_dining: "Comedor al aire libre",
      breakfast: "Desayuno",
      pool: "Piscina",
      shared_pool: "Piscina comunitaria",
      garden: "Patio trasero",
      patio_balcony: "Patio o balcón",
      outdoor_furniture: "Mobiliario exterior",
      sun_loungers: "Tumbonas",
      hammock: "Hamaca",
      fire_pit: "Brasero exterior",
      shared_fireplace: "Chimenea en zona común",
      sauna: "Sauna",
      beach_essentials: "Básicos de playa",
      beach_access: "Acceso a la playa",
      lake_access: "Acceso al lago",
      resort_access: "Acceso al resort",
      waterfront: "Junto al agua",
      dock: "Atracadero para barcos",
      kayak: "Kayak",
      bikes: "Bicicletas",
      ski_slope: "Pista de esquí",
      outdoor_playground: "Parque infantil al aire libre",
      tv: "TV",
      sound_system: "Sistema de sonido",
      record_player: "Tocadiscos",
      piano: "Piano",
      gym: "Gimnasio",
      exercise_equipment: "Máquinas para hacer ejercicio",
      games: "Juegos de mesa",
      giant_games: "Juegos gigantes",
      pool_table: "Mesa de billar",
      ping_pong: "Mesa de pimpón",
      bowling: "Bolera",
      arcade: "Juegos recreativos",
      minigolf: "Minigolf",
      batting_cage: "Jaula de bateo",
      ice_rink: "Pista de hockey sobre hielo",
      laser_tag: "Laser tag",
      skate_ramp: "Rampa de skate",
      climbing_wall: "Rocódromo",
      game_console: "Videoconsola",
      books: "Libros y material de lectura",
      cinema: "Cine",
      themed_room: "Habitación temática",
      smoke_detector: "Detector de humo",
      co_detector: "Detector de monóxido de carbono",
      fire_extinguisher: "Extintor de incendios",
      first_aid_kit: "Botiquín",
      fire_guard: "Salvachispas",
      safe: "Caja fuerte",
      gated_community: "Urbanización cerrada",
      security_cameras: "Cámaras de seguridad",
      children_allowed: "Se permiten niños",
      crib: "Cuna",
      travel_cot: "Parque/cuna de viaje",
      baby_bath: "Bañera para bebés",
      baby_safety_gates: "Barreras de seguridad para bebés",
      changing_table: "Cambiador",
      high_chair: "Trona",
      children_plates: "Platos y cubiertos para niños",
      children_books_toys: "Libros y juguetes para niños",
      kids_bikes: "Bicicletas para niños",
      outlet_covers: "Protectores de enchufes",
      table_corner_guards: "Protectores para las esquinas de las mesas",
      window_guards: "Protecciones en las ventanas",
      baby_monitor: "Monitor de bebés",
      children_game_room: "Sala de juegos infantil",
      babysitter_recommendations: "Recomendaciones de canguros",
      parking: "Aparcamiento gratuito en las instalaciones",
      free_street_parking: "Aparcamiento gratuito en la calle",
      paid_parking_on_premises: "Aparcamiento de pago en las instalaciones",
      paid_parking_off_premises: "Aparcamiento de pago fuera de las instalaciones",
      ev_charger: "Cargador para coches eléctricos",
      e_bike_charger: "Cargador de bicis eléctricas",
      pets_allowed: "Se permiten mascotas",
      long_term_stays: "Disponible para estancias largas",
      luggage_dropoff: "Se permite dejar el equipaje",
      cleaning_during_stay: "Limpieza disponible durante la estancia",
      concierge: "Portero",
      cleaning_products: "Productos de limpieza",
      recycling: "Cubos de reciclaje",
      compactor: "Compactador de residuos",
      compost: "Compostera",
      solar_panels: "Paneles solares",
      workspace: "Zona para trabajar",
      private_entrance: "Entrada privada",
      private_lounge: "Salón privado",
      mosquito_net: "Mosquitera",
      ceiling_fan: "Ventilador de techo",
      portable_fans: "Ventiladores portátiles",
      ethernet: "Conexión Ethernet",
      mobile_wifi: "Wifi móvil",
      single_floor: "Alojamiento de una altura",
      elevator: "Ascensor",
    },
  },

  room: {
    createTitle: "Registrar tipo de habitación",
    editTitle: "Actualizar tipo de habitación",
    namePlaceholder: "Ej: Habitación Doble",
    countLabel: "Cantidad de habitaciones de este tipo",
    countPlaceholder: "Ej: 20",
    countHint: "Esto representa el inventario total del tipo. Ej: “Doble” = 20 habitaciones.",
    capacityLabel: "Capacidad total (máx. huéspedes)",
    capacityPlaceholder: "Ej: 5",
    capacityHint:
      "Este es el límite real de huéspedes. Aunque pongas máximos por categoría, el total manda.",
    maxAdults: "Máx. Adultos",
    maxChildren: "Máx. Niños",
    maxInfants: "Máx. Bebés",
    importantLabel: "Importante:",
    capacityNote: "estos son topes por categoría. El total permitido lo define “Capacidad total”.",
    physicalTitle: "Habitaciones físicas (RoomInstances)",
    physicalDesc: "Actívalo si quieres manejar 101/102, mantenimiento por habitación y cerraduras.",
    generateLabel: "Generar/Ajustar habitaciones físicas automáticamente",
    generatorTitle: "Generador de códigos",
    prefixLabel: "Prefijo",
    prefixPlaceholder: "Ej: 10 o A-",
    prefixHint: "Ej: prefijo “10” + inicio 1 => 101,102...",
    startLabel: "Inicio",
    paddingLabel: "Padding",
    paddingHint: "Ej: pad 3 => 001,002,003",
    nameModeType: "Solo tipo",
    nameModeTypeCode: "Tipo + código",
    defaultDescLabel: "Descripción por defecto",
    willCreatePre: "Se crearán o ajustarán hasta",
    willCreatePost: "habitaciones físicas automáticamente.",
    errors: {
      saveFallback: "Error al guardar tipo de habitación.",
      capacityMin: "La capacidad total debe ser al menos 1.",
      adultsMin: "Debe haber al menos 1 adulto permitido.",
      adultsMax: "El límite de adultos no puede ser mayor que la capacidad total.",
      childrenRange: "El límite de niños debe estar entre 0 y la capacidad total.",
      infantsRange: "El límite de bebés debe estar entre 0 y la capacidad total.",
      roomsMin: "La cantidad de habitaciones debe ser al menos 1.",
      notAuth: "Usuario no autenticado.",
    },
    toasts: {
      updated: "Tipo actualizado.",
      created: "Tipo creado.",
      roomsSynced: "Habitaciones físicas generadas/ajustadas correctamente.",
    },
  },

  rate: {
    registerHeader: "Registrar tipo de habitación",
    editHeader: "Actualizar tarifa - {name}",
    createHeader: "Registrar tarifa - {name}",
    processing: "Procesando, por favor espere.",
    general: "General",
    namePlaceholder: "Nombre personalizado",
    validityLabel: "Periodo de validez",
    permanent: "Permanente",
    custom: "Personalizado",
    startDatePlaceholder: "Fecha de inicio",
    endDatePlaceholder: "Fecha de fin",
    validityNoteCustom: "Periodo de validez de la tarifa (opcional)",
    validityNotePermanent: "Tarifa válida de forma permanente",
    pricePerNight: "Precio por noche",
    taxIncluded: "Impuestos incluidos",
    occupancy: "Ocupación",
    guestsNumber: "Número de huéspedes",
    minStay: "Reserva Mínima",
    minStayNote: "Noches mínimas a facturar",
    maxStay: "Reserva Máxima",
    maxStayNote: "Límite de noches a reservar",
    errors: {
      rangeRequired: "Debe seleccionar un rango de fechas válido",
      startAfterEnd: "La fecha de inicio no puede ser mayor a la fecha de fin",
      minStay:
        "La estancia mínima es de {minStay} noches, pero el rango seleccionado tiene {nights} noches",
    },
  },
};
